import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APIURL, TZ } from "../../../Global";
import AddBanner from './AddBanner';
import WasabiImage from './WasabiImage';
import './MasterBanners.css';
import { useTranslation } from 'react-i18next';

// Function to categorize banners
const categorizeBanners = (banners) => {
  if (!banners || banners.length === 0) return [];
  
  // Group by screen_type and store banner details with banner_type_name for display
  const byScreenType = {};
  banners.forEach(banner => {
    const screenType = banner.banner_space_details?.screen_type || 'web';
    if (!byScreenType[screenType]) {
      byScreenType[screenType] = {};
    }
    const bannerTypeName = banner.banner_type_name;
    const spaceName = banner.space_name;
    
    // For Web: Group hero_banner, hero_small_top, and hero_small_bottom under "Hero Banner"
    // Group middle_banner and middle_small_banner under "Hero Banner Product"
    if (screenType === 'web') {
      if (['hero_banner', 'hero_small_top', 'hero_small_bottom'].includes(bannerTypeName)) {
        if (!byScreenType[screenType]['hero_banner']) {
          byScreenType[screenType]['hero_banner'] = {
            id: 'hero_banner_grouped',
            displayName: 'Hero Banner',
            spaceName: 'Hero Banner',
            bannerTypes: [] // Store individual types for filtering
          };
        }
        byScreenType[screenType]['hero_banner'].bannerTypes.push(bannerTypeName);
      } else if (['middle_banner', 'middle_small_banner'].includes(bannerTypeName)) {
        if (!byScreenType[screenType]['middle_banner']) {
          byScreenType[screenType]['middle_banner'] = {
            id: 'hero_banner_product_grouped',
            displayName: 'Hero Banner Product',
            spaceName: 'Hero Banner Product',
            bannerTypes: []
          };
        }
        byScreenType[screenType]['middle_banner'].bannerTypes.push(bannerTypeName);
      } else {
        // For other web banners, keep as is
        if (!byScreenType[screenType][bannerTypeName]) {
          byScreenType[screenType][bannerTypeName] = {
            id: bannerTypeName,
            displayName: spaceName,
            spaceName: spaceName
          };
        }
      }
    } else {
      // For App banners, keep original logic
      if (!byScreenType[screenType][bannerTypeName]) {
        byScreenType[screenType][bannerTypeName] = {
          id: bannerTypeName, // For filtering
          displayName: spaceName, // For display and translation lookup
          spaceName: spaceName // Store space_name for translation key
        };
      }
    }
  });
  
  // Create menu structure
  const menuData = [];
  Object.keys(byScreenType).forEach(screenType => {
    const subMenus = Object.values(byScreenType[screenType]);
    if (subMenus.length > 0) {
      menuData.push({
        title: `${screenType}_banners`,
        subMenus: subMenus
      });
    }
  });
  
  return menuData;
};

const MasterBanners = () => {
  const { t } = useTranslation();
  const [dynamicMenuData, setDynamicMenuData] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState('');
  const [selectedSubMenu, setSelectedSubMenu] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [bannerDatas,setBannerData]=useState([])
  const [filteredBanners, setFilteredBanners] = useState([]);
  const [bannerToUpdate, setBannerToUpdate] = useState(null);
  const [refresh,setRefresh]=useState(false)


  useEffect(() => {
    const fetchBanners = async () => {
      const tokenString = sessionStorage.getItem('usertoken');
      let str = tokenString.replace(/["]+/g, '');
      try {
        const res = await axios.get(`${APIURL}/api/v1/staff/banner-upload/?${TZ}`, {
          headers: {
            "Authorization": 'Token ' + str
          }
        });
        if (res.data.status === 'success') {
          setBannerData(res.data);
          // Categorize banners by screen_type and banner_type_name
          const categorized = categorizeBanners(res.data.data);
          setDynamicMenuData(categorized);
          // Set default selection only on initial load
          if (categorized.length > 0 && !selectedMenu && !refresh) {
            setSelectedMenu(categorized[0].title);
            const firstSubMenu = categorized[0].subMenus[0];
            setSelectedSubMenu(typeof firstSubMenu === 'object' ? firstSubMenu.id : firstSubMenu);
          }
        }
      } catch (err) {
        // Optionally handle error
        setBannerData([]);
      }
    };
    fetchBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    if (bannerDatas && bannerDatas.data && selectedSubMenu && selectedMenu) {
      // Extract screen type from selected menu (e.g., "web_banners" -> "web")
      const screenType = selectedMenu.replace('_banners', '');
      
      // Check if this is a grouped submenu
      const selectedSubMenuItem = dynamicMenuData
        .find(menu => menu.title === selectedMenu)?.subMenus
        .find(sub => sub.id === selectedSubMenu);
      
      const filtered = bannerDatas.data.filter(
        (item) => {
          const itemScreenType = item.banner_space_details?.screen_type || 'web';
          // If grouped, check if banner type is in the group
          if (selectedSubMenuItem?.bannerTypes) {
            return selectedSubMenuItem.bannerTypes.includes(item.banner_type_name) && itemScreenType === screenType;
          } else {
            // Regular filtering
            return item.banner_type_name === selectedSubMenu && itemScreenType === screenType;
          }
        }
      );
      setFilteredBanners(filtered);
    } else {
      setFilteredBanners([]);
    }
  }, [selectedSubMenu, selectedMenu, bannerDatas, dynamicMenuData]);
  const handleMenuClick = (menu) => {
    setSelectedMenu(menu.title);
    setSelectedSubMenu(menu.subMenus[0].id || menu.subMenus[0]);
  };

  const handleSubMenuClick = (subMenu) => {
    setSelectedSubMenu(subMenu.id || subMenu);
  };

  const handleUpdateBanner = (banner) => {
    setBannerToUpdate(banner);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    
    setShowModal(false);
    setRefresh(!refresh)
    setBannerToUpdate(null);
  };
console.log(filteredBanners,"fb")
  // Example: Render different content based on selected submenu
  const renderContent = () => {
    return (
      <div>
        {filteredBanners.length === 0 ? (
          <div style={{padding: '32px', color: '#888'}}>No banners found for this space.</div>
        ) : (
          <div>
            {filteredBanners.map((banner) => (
              <div key={banner.id} className="banner-card" >
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div >
                    <strong>{t(`banners.${banner.title}`, { defaultValue: banner.title })}</strong>
                  </div>
                  <button
                    className="create-btn"
                    onClick={() => handleUpdateBanner(banner)}
                  >
                    {t('banners.update')}
                  </button>
                </div>
                <div className='row'>
                   
                {banner.image_detail && banner.image_detail.length > 0 && (
                  <div className="banner-image-list col-7" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    {banner.image_detail.map((img, idx) => {
                      const fileName = img.url;
                      const alt = img.title;
                      const width = banner.banner_space_details?.width;
                      const height = banner.banner_space_details?.height;
                      const bucketName = bannerDatas.bucket_name;
                      const allPresent = bucketName && fileName;
                      return (
                        <div key={idx} style={{display: 'flex', flexDirection: 'column', alignItems: 'center',width: '100%'}}>
                          {allPresent ? (
                            <WasabiImage
                              bucketName={bucketName}
                              fileName={fileName}
                              alt={alt}
                              width={width}
                              height={height}
                              from="masterBanners"
                            />
                          ) : (
                            <span>Image info missing</span>
                          )}
                          {/* <span style={{marginTop: 6, color: '#666', fontSize: '0.95em'}}>{img.title}</span> */}
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className='col-5'>
                <div className="det-div " style={{marginTop:'20px'}}>
        <div className='row'>
          <div className='col-12'>
          <div className="row " style={{padding:"2%"}}>
            <div className="col-sm-12">
              <p className=" text-left">{t('banners.ID')} :  <span className='text-info span-size'>{banner.id}</span></p>
              
            </div>
            <div className="col-sm-12">
              <p className="text-left">{t('banners.Title')} : <span className='text-info span-size'>{t(`banners.${banner.title}`, { defaultValue: banner.title })}</span> </p>
             
            </div>

            <div className="col-sm-12">
              <p className=" text-left">{t('banners.Screen type')} : <span className='text-info span-size'>{banner.banner_space_details.screen_type.charAt(0).toUpperCase() + banner.banner_space_details.screen_type.slice(1)}</span></p>
              
            </div>
             <div className="col-sm-12">
              <p className=" text-left">{t('banners.Width')} : <span className='text-info span-size'>{banner.banner_space_details.width}px</span></p>
             
            </div>

            <div className="col-sm-12">
              <p className="text-left">{t('banners.Height')} : <span className='text-info span-size'>{banner.banner_space_details.height}px</span></p>
             
            </div>


            {/* <div className="col-sm-6">
              <p className="text-left">{t('banners.Price')} : <span className='text-info span-size'><b>{banner.banner_space_details.price}</b></span></p>
            
            </div> */}

          

          
        </div>
          </div>
        
        </div>

         
   

     

</div>
                </div>
              </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{background: '#f6fafd', minHeight: '100vh'}}>
      <div className="master-banners-layout">
        <div className="side-menu">
          <div style={{fontWeight: 700, fontSize: '1.1rem', color: '#1ec6b6', padding: '0 24px 18px 24px', letterSpacing: 1}}>Banners</div>
          {dynamicMenuData.length > 0 ? (
            dynamicMenuData.map((menu) => (
              <div key={menu.title}>
                <div
                  className={`menu-title${selectedMenu === menu.title ? ' active' : ''}`}
                  onClick={() => handleMenuClick(menu)}
                >
                  {t(`banners.${menu.title}`) || menu.title.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                </div>
                {selectedMenu === menu.title && (
                  <div className="sub-menu-list">
                    {menu.subMenus.map((sub) => {
                      const subId = typeof sub === 'object' ? sub.id : sub;
                      const subDisplayName = typeof sub === 'object' ? sub.displayName : sub;
                      const subSpaceName = typeof sub === 'object' ? sub.spaceName : null;
                      return (
                        <div
                          style={{textTransform:"capitalize"}}
                          key={subId}
                          className={`sub-menu${selectedSubMenu === subId ? ' active' : ''}`}
                          onClick={() => handleSubMenuClick(sub)}
                        >
                          {subSpaceName ? t(`banners.${subSpaceName}`, { defaultValue: subDisplayName }) : subDisplayName}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div style={{padding: '20px', color: '#888'}}>Loading banners...</div>
          )}
        </div>
        <div className="right-content">
          {renderContent()}
          {showModal && bannerToUpdate && (
            <div className="modal-overlay-addbanner" onClick={handleCloseModal}>
              <div className="modal-content-addbanner" onClick={e => e.stopPropagation()}>
                <button className="cancel-btn1" onClick={handleCloseModal}>X</button>
                <AddBanner
                  banner={bannerToUpdate}
                  token={sessionStorage.getItem('usertoken')?.replace(/["]+/g, '')}
                  onSuccess={handleCloseModal}
                  onError={() => {}}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MasterBanners;
